var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.6,
    height: 25.6,
    viewBox: "0 0 25.6 25.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-normal",
    transform: "translate(0.8 0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_twotone_search-normal",
    "data-name": "vuesax/twotone/search-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-normal-2",
    "data-name": "search-normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.5,19A9.5,9.5,0,1,1,19,9.5,9.5,9.5,0,0,1,9.5,19Z",
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#1f6bc0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2,2,0,0",
    transform: "translate(20 20)",
    fill: "none",
    stroke: "#1f6bc0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    strokeDasharray: "0 0",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M24,0V24H0V0Z",
    fill: "none",
    stroke: "#1f6bc0",
    strokeWidth: 1.6,
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b64ed079fa263e46c433ffa9d333c7d7.svg";
export { ForwardRef as ReactComponent };